import bem from 'utils/bem';

export const block = bem('upload-captions-modal');

export const SUPPORTED_CAPTION_TYPE_EXTENSIONS = ['.vtt', '.srt', '.docx'];
